// VerticalSlider.jsx
import React, { useState, useEffect } from 'react';
import MuiSlider from '@mui/material/Slider';
import './slider_vertical.css';

// Sentinela para infinito en el UI del slider
const SLIDER_INFINITY = 460;

// Mapea valores del slider -> claves FL_MAP
const valueToKey = {
  0: 'Surface',
  25: 'Above FL25',
  50: 'Above FL50',
  75: 'Above FL75',
  100: 'Above FL100',
  125: 'Above FL125',
  150: 'Above FL150',
  175: 'Above FL175',
  200: 'Above FL200',
  225: 'Above FL225',
  250: 'Above FL250',
  275: 'Above FL275',
  300: 'Above FL300',
  325: 'Above FL325',
  350: 'Above FL350',
  375: 'Above FL375',
  400: 'Above FL400',
  425: 'Above FL425',
  450: 'Above FL450',
  [SLIDER_INFINITY]: 'Above ∞'
};

// Para mostrar etiquetas (no cambies FL_MAP)
const formatLabel = (key) => {
  if (key === 'Surface') return 'Surface';
  if (key === 'Above ∞') return 'Above ∞';
  return key;
};

// cache opcional si quieres persistir entre montajes
let sliderRangeCache = [0, SLIDER_INFINITY];

function VerticalSlider({ selectedCategory, setSelectedCategory }) {
  const [sliderRange, setSliderRange] = useState(sliderRangeCache);

  // Mantén el UI sincronizado si selectedCategory cambia desde fuera
  useEffect(() => {
    const keyToValue = (key) => {
      const entry = Object.entries(valueToKey)
        .find(([, k]) => k === key);
      return entry ? Number(entry[0]) : 0;
    };
    const uiRange = [ keyToValue(selectedCategory[0]), keyToValue(selectedCategory[1]) ];
    setSliderRange(uiRange);
    sliderRangeCache = uiRange;
  }, [selectedCategory]);

  const handleSliderChange = (_event, newValue) => {
    setSliderRange(newValue);
    sliderRangeCache = [...newValue];
    const newKeys = newValue.map(v => valueToKey[v] ?? (v === 0 ? 'Surface' : `Above FL${v}`));
    setSelectedCategory(newKeys);
  };

  return (
    <div className="cql-control">
      {/* Icono avión + etiqueta ALTITUDE — sin fondo */}
      <div className="fl-header">
        <span className="fl-header-icon">✈</span>
        <span className="fl-header-label">FL ALTITUDE</span>
        <span className="fl-header-label">SELECTOR</span>
      </div>

      <MuiSlider
        orientation="vertical"
        min={0}
        max={SLIDER_INFINITY}
        step={null}                  // solo paradas en 'marks'
        value={sliderRange}
        onChange={handleSliderChange}
        disableSwap
        marks={Object.keys(valueToKey).map(v => ({ value: Number(v) }))}
        valueLabelDisplay="on"
        valueLabelFormat={(value, index) => {
          const key = valueToKey[value] ?? (value === 0 ? 'Surface' : `Above FL${value}`);
          const lbl = formatLabel(key);
          // Pulgar superior → ↓  (techo),  pulgar inferior → ↑  (suelo)
          if (index === 1) return lbl.replace(/^Above/, '↓');
          return lbl.replace(/^Above/, '↑');
        }}
        sx={{
          height: '32vh',
          '& .MuiSlider-thumb': { 
            height: 14, width: 14, backgroundColor: '#fff', border: '2px solid #1976d2',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            '&.Mui-active, &:hover': { height: 18, width: 18, boxShadow: '0 3px 10px rgba(0,0,0,0.3)' } 
          },
          '& .MuiSlider-track': { 
            background: 'linear-gradient(to top, #4fc3f7, #1976d2)',
            border: 'none',
            width: 4,
            borderRadius: '4px'
          },
          '& .MuiSlider-rail': { 
            background: 'linear-gradient(to top, #81c784 0%, #64d8cb 25%, #4fc3f7 50%, #1976d2 75%, #0d47a1 100%)',
            opacity: 0.35,
            width: 4,
            borderRadius: '4px'
          },
          '& .MuiSlider-mark': { 
            backgroundColor: 'rgba(255, 255, 255, 0.5)', 
            height: 4, 
            width: 4, 
            borderRadius: '50%',
            transform: 'translateX(-50%)' 
          },
          '& .MuiSlider-markActive': {
            backgroundColor: '#fff',
            height: 5,
            width: 5,
          },
          '& .MuiSlider-valueLabel': {
            lineHeight: 1.2, fontSize: '0.75rem', backgroundColor: '#1976d2', color: 'white',
            borderRadius: '8px', padding: '3px 6px', fontWeight: 'bold',
            fontFamily: '"Open Sans", sans-serif',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:before': { display: 'none' },
          },
        }}
      />
    </div>
  );
}

export default VerticalSlider;
